import once from "src/lib/once";
import trackPageviewVariant from "./events/track-page-view-variant";

const createTrackPageviewVariant = (callback = () => {}) => {
  return once(({ activeVariantId }) => {
    trackPageviewVariant({
      variantId: activeVariantId,
    });
    callback();
  });
};

export default createTrackPageviewVariant;
